import addBorderInHighContrastMode from '@/lib/styling/addBorderInHighContrastMode';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { IconButton } from '@mui/material';

const TonalIconButton = styled(IconButton)(
  ({ theme }) => ({
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.action.hover,
    ':hover': {
      backgroundColor: theme.palette.action.selected,
    },
  }),
  addBorderInHighContrastMode,
  addHighContrastStyles(({ theme }) => {
    if (!theme.isDark) {
      return null;
    }

    return {
      backgroundColor: 'black',
      ':hover': {
        backgroundColor: 'transparent',
      },
    };
  }),
);

export default TonalIconButton;
